import { Validator } from 'vee-validate';

Validator.extend('password_lower', {
    getMessage: field => 'Passwords should have a lowercase.',
    validate: value => new RegExp('[a-z]').test(value) 
});

Validator.extend('password_upper', {
    getMessage: field => 'Passwords should have an uppercase.',
    validate: value => new RegExp('[A-Z]').test(value) 
});

Validator.extend('password_numeric', {
    getMessage: field => 'Passwords need a number.',
    validate: value => new RegExp('[0-9]').test(value) 
});



// WEBPACK FOOTER //
// ./Content/js/app/custom-validation.js